import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const orderStatisticService = {};

// List reason why delete order
orderStatisticService.countOrderByHub = ({ params }) => {
  const { columnFilter, columnFilterKeep } = params;
  return fetchV2({
    url: `${env.API_MSP}/dashboard/count-order-by-hub`,
    method: "get",
    params: {
      ...columnFilterKeep,
      ...columnFilter,
    },
  });
};

// List reason why delete order
orderStatisticService.countOrderByRunner = ({ params }) => {
  const { columnFilter, columnFilterKeep } = params;
  return fetchV2({
    url: `${env.API_MSP}/dashboard/count-order-by-runner-hub`,
    method: "get",
    params: {
      ...columnFilterKeep,
      ...columnFilter,
    },
  });
};

export default orderStatisticService;
